import { create } from 'zustand';
import { INITIAL_CENTER, INITIAL_ZOOM } from 'src/data';

export const useMapStore = create((set, get) => ({
    mapInstance: null,
    setMapInstance: (map) => set({ mapInstance: map }),

    lastCameraPosition: null,
    setLastCameraPosition: (position) => set({ lastCameraPosition: position }),

    center: INITIAL_CENTER,
    zoom: INITIAL_ZOOM,
    minZoom: 2,
    maxZoom: 12,

    setCenter: (center) => set({ center }),
    setZoom: (zoom) => set({ zoom }),

    controlsInitialized: false,
    setControlsInitialized: (initialized) => set({ controlsInitialized: initialized }),
    
    hasGeolocateRun: false,
    setHasGeolocateRun: (hasRun) => set({ hasGeolocateRun: hasRun }),

    mapContainerRef: null,
    setMapContainerRef: (ref) => set({ mapContainerRef: ref }),
    
    flyTo: (center, zoom = undefined) =>
        set((state) => {
            if (state.mapInstance) {
                state.mapInstance.flyTo({
                    center: center,
                    zoom: zoom ?? state.zoom,
                    speed: 1.2,
                    curve: 1.42,
                    essential: true,
                    padding: { top: 0, bottom: 0, left: 0, right: 0 }
                });
            }
            return {
                center,
                zoom: zoom ?? state.zoom,
            };
    }),

    // Cleanup functions registry
    cleanupFunctions: [],
    registerCleanup: (cleanupFn) => {
        const { cleanupFunctions } = get();
        set({ cleanupFunctions: [...cleanupFunctions, cleanupFn] });
    },
    unregisterCleanup: (cleanupFn) => {
        const { cleanupFunctions } = get();
        set({ cleanupFunctions: cleanupFunctions.filter(fn => fn !== cleanupFn) });
    },
    clearMapFeatures: () => {
        const { cleanupFunctions, mapInstance } = get();
        
        // Run all registered cleanup functions
        cleanupFunctions.forEach(fn => fn());
        
        // Clear map layers/sources
        if (mapInstance) {
            const layersToRemove = ['panam-symbols'];
            const sourcesToRemove = ['panam-pins'];
            
            layersToRemove.forEach(layerId => {
                if (mapInstance.getLayer(layerId)) {
                    mapInstance.removeLayer(layerId);
                }
            });
            
            sourcesToRemove.forEach(sourceId => {
                if (mapInstance.getSource(sourceId)) {
                mapInstance.removeSource(sourceId);
                }
            });
        }
    },

    clearTripData: () => {
        const { mapInstance } = get();
        if (mapInstance) {
            // Remove trip-specific sources and layers
        if (mapInstance.getLayer('route')) {
            mapInstance.removeLayer('route');
        }
        if (mapInstance.getSource('route')) {
            mapInstance.removeSource('route');
        }
        // Add any other trip-specific cleanup here
        }
    },
    
    // Method to reset state (useful for testing or logout)
    resetState: () => {
        set({
            lastCameraPosition: null,
            controlsInitialized: false,
            hasGeolocateRun: false,
            cleanupFunctions: []
        });
    },
  
    // Method to clean up when app closes
    cleanup: () => {
        const { mapInstance, cleanupFunctions } = get();
        
        // Run all cleanup functions
        cleanupFunctions.forEach(fn => fn());
        
        if (mapInstance) {
            mapInstance.remove();
            set({ 
                mapInstance: null, 
                lastCameraPosition: null,
                controlsInitialized: false,
                hasGeolocateRun: false,
                cleanupFunctions: []
            });
        }
    }
    
}));
